"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3484],{

/***/ 17251:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ SafenSecureTrav_SafenSecureTrav)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(20984);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTrav.style.ts




const SafenSecureTravStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravStyle",
  componentId: "e1cu42-0"
})(["width:100%;background:", ";position:relative;z-index:1;overflow:hidden;", "{width:64%;}@media ", "{padding:0 16px;}"], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ ? `none` : `#fff`, TextStyles_style/* H2TagStyle */.FI, utils/* deviceType.mobile */.vO.mobile);
const SafenSecureTravCrdStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureTravCrdStyle",
  componentId: "e1cu42-1"
})(["background:", ";border-radius:14px;padding:24px;flex:1;position:relative;display:flex;flex-direction:column;gap:24px;> img{position:absolute;right:30px;bottom:24px;}@media ", "{gap:12px;}"], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ ? `
linear-gradient(128.03deg, rgba(247, 237, 227, 0.36) 2.1%, rgba(255, 240, 230, 0.441706) 49.06%, rgba(244, 231, 214, 0.6) 80.75%);
` : `linear-gradient(
      128.03deg,
      rgba(227, 247, 245, 0.36) 2.1%,
      rgba(230, 237, 255, 0.441706) 49.06%,
      rgba(214, 232, 244, 0.6) 80.75%
    ),
    #fcffff;`, utils/* deviceType.mobile */.vO.mobile);
const FeatList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "SafenSecureTravstyle__FeatList",
  componentId: "e1cu42-2"
})(["display:flex;flex-direction:", ";gap:", ";max-width:80%;li{position:relative;padding-left:14px;}li:after{content:\"\";position:absolute;background:#000000;border-radius:2px;width:4px;height:14px;top:6px;left:0;}@media ", "{margin-bottom:12px;flex-direction:column;gap:16px;}"], p => p.cardQuantity === 1 ? "row" : "column", p => p.cardQuantity === 1 ? "50px" : "16px", utils/* deviceType.mobile */.vO.mobile);
const SafenSecureBgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SafenSecureTravstyle__SafenSecureBgWrap",
  componentId: "e1cu42-3"
})(["position:absolute;top:17px;right:-122px;width:100%;z-index:-1;height:558px;img{width:100%;height:558px;}", ""], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ ? `
    display: none;` : null);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTravCrd.tsx







const SafenSecureTravCrd = ({
  title,
  featList,
  cardImg,
  poweredBy,
  additionalInfo,
  cardQuantity
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravCrdStyle, {
    "data-test-id": "SafenSecureTravCrd-SafenSecureTravCrdStyle",
    children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
      "data-test-id": "SafenSecureTravCrd-H5Tag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      fontWeight: "black",
      fontSize: "large",
      margin: device == "sm" ? "" : "0 0 12px",
      "data-test-id": "SafenSecureTravCrd-ParaTag",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "SafenSecureTravCrd-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FeatList, {
      cardQuantity: cardQuantity,
      "data-test-id": "SafenSecureTravCrd-FeatList",
      children: featList && featList?.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          "data-test-id": `SafenSecureTravCrd-${index}`,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: item,
            "data-test-id": "SafenSecureTravCrd-FormattedText"
          })
        }, index);
      })
    }), poweredBy && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      margin: "auto 0 0",
      gap: "20px",
      alignItems: "Center",
      "data-test-id": "SafenSecureTravCrd-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        "data-test-id": "SafenSecureTravCrd-SpanTag",
        children: "Powered By"
      }), poweredBy && poweredBy.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          src: item,
          height: "32px",
          width: "auto",
          "data-test-id": `SafenSecureTravCrd-ImageComponent-${index}`
        }, index);
      })]
    }), additionalInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
      value: additionalInfo,
      "data-test-id": "SafenSecureTravCrd-FormattedText"
    }), cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
      width: device == "lg" ? cardQuantity === 1 ? "auto" : "92px" : "54px",
      height: device == "lg" ? cardQuantity === 1 ? "126px" : "102px" : "60px",
      src: cardImg,
      "data-test-id": "SafenSecureTravCrd-ImageComponent"
    })]
  });
};

/* harmony default export */ const SafenSecureTrav_SafenSecureTravCrd = (SafenSecureTravCrd);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTrav.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














const SafenSecureTrav = ({
  title,
  data
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(() => {
    (0,XDMAnalytics.trackComponentView)({
      name: "section_2_shown",
      type: "card"
    });

    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "safe_n_secure_trav_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: intersectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SafenSecureTravStyle, {
    ref: intersectionRef,
    "data-test-id": "SafenSecureTrav-SafenSecureTravStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureBgWrap, {
      "data-test-id": "SafenSecureTrav-SafenSecureBgWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "100%",
        height: "558px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/safen_Secure_Bg_200cfd8d5c.svg",
        "data-test-id": "SafenSecureTrav-ImageComponent"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "SafenSecureTrav-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H2Tag, {
        margin: "0 0 60px",
        "data-test-id": "SafenSecureTrav-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
        margin: "0 0 20px",
        "data-test-id": "SafenSecureTrav-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "SafenSecureTrav-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
        gap: device == "lg" ? "60px" : "20px",
        flexDirection: device == "sm" ? "column" : "row",
        flexWrap: "wrap",
        "data-test-id": "SafenSecureTrav-FlexComp",
        children: data && data.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SafenSecureTrav_SafenSecureTravCrd, _objectSpread(_objectSpread({
            cardQuantity: data?.length
          }, item), {}, {
            "data-test-id": `SafenSecureTrav-SafenSecureTravCrd-${index}`
          }), index);
        })
      })]
    })]
  });
};

/* harmony default export */ const SafenSecureTrav_SafenSecureTrav = (SafenSecureTrav);

/***/ }),

/***/ 52287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ SectionDividersStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);

const SectionDividersStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionDividersstyle__SectionDividersStyle",
  componentId: "sc-1legtm0-0"
})(["background:", ";width:", ";height:", ";border-radius:", ";margin:", ";", ";", ";", ";flex-shrink:0;"], p => p.backgroundColor ? `${p.backgroundColor}` : `#f2f2f2`, p => p.width ? p.width : "unset", p => p.height ? p.height : "4px", p => p.borderRadius ? p.borderRadius : "0px", p => p.margin ? p.margin : "0px", p => p.xs && `height: 1px;`, p => p.small && `height: 10px;`, p => p.large && `height: 25px;`);

/***/ }),

/***/ 27154:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _SectionDividers_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52287);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);



const SectionDividers = ({
  small,
  large,
  xs,
  width,
  height,
  borderRadius,
  margin,
  backgroundColor
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SectionDividers_style__WEBPACK_IMPORTED_MODULE_0__/* .SectionDividersStyle */ .$, {
    backgroundColor: backgroundColor,
    small: small,
    large: large,
    xs: xs,
    width: width,
    height: height,
    borderRadius: borderRadius,
    margin: margin,
    "data-test-id": "SectionDividers-SectionDividersStyle"
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SectionDividers);

/***/ }),

/***/ 68314:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ SecureTravOffer_SecureTravOffer)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SecureTravOffer/SecureTravOffer.style.ts




const SecureTravOfferStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravOfferStyle",
  componentId: "pvlpoe-0"
})(["display:flex;flex-direction:column;gap:24px;svg{flex-shrink:0;}", "{font-size:22px;font-weight:900;}"], TextStyles_style/* H5TagStyle */.Wl);
const SecureTravItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravItem",
  componentId: "pvlpoe-1"
})(["display:flex;gap:24px;@media ", "{gap:8px;}"], utils/* deviceType.mobile */.vO.mobile);
const SecureTravImgWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravImgWrap",
  componentId: "pvlpoe-2"
})(["background:linear-gradient( 125.09deg,#474747 0%,rgba(255,255,255,0) 64.55% );border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:72px;height:80px;", ""], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MMT ? `
     background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);
    ` : p.theme.pageTheme === isomorphic_utils_src.PARTNER.GI ? `background: linear-gradient(113deg, rgba(211, 211, 211, 0.30) 0%, rgba(255, 255, 255, 0.00) 87.26%);` : `
    `);
const SecureTravContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecureTravOfferstyle__SecureTravContent",
  componentId: "pvlpoe-3"
})(["align-self:center;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SecureTravOffer/SecureTravOffer.tsx









const SecureTravOffer = ({
  data
}) => {
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravOfferStyle, {
    "data-test-id": "SecureTravOffer-SecureTravOfferStyle",
    children: data && data.map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravItem, {
        "data-test-id": `SecureTravOffer-SecureTravItem-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SecureTravImgWrap, {
          "data-test-id": "SecureTravOffer-SecureTravImgWrap",
          children: item.travImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "48px",
            height: "48px",
            src: item.travImg,
            loading: "eager",
            "data-test-id": "SecureTravOffer-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecureTravContent, {
          "data-test-id": "SecureTravOffer-SecureTravContent",
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-H5Tag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
            fontSize: "md",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: item.title,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          }), item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
            margin: device == "lg" ? "16px 0 0" : "8px 0 0",
            fontSize: device == "lg" ? "sm" : "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "SecureTravOffer-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: item.info,
              "data-test-id": "SecureTravOffer-FormattedText"
            })
          })]
        })]
      }, index);
    })
  });
};

/* harmony default export */ const SecureTravOffer_SecureTravOffer = (SecureTravOffer);

/***/ }),

/***/ 68003:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ SelectCountryModal_CountryList)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-window/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__(88475);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CheckButton/CheckButton.tsx
var CheckButton = __webpack_require__(97004);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/AnchorTag.tsx
var AnchorTag = __webpack_require__(38985);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/CountryList.style.tsx

const ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CountryListstyle__ArrowButtonWrap",
  componentId: "sc-10iz6l5-0"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
const DescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__DescriptionWrap",
  componentId: "sc-10iz6l5-1"
})(["cursor:none;margin:10px 0px 0px 32px;border-radius:4px;padding:10px 6px 10px 10px;background-color:#f6f6f6;cursor:", ";"], props => props.isCursorPointer ? "pointer" : "default");
const ColumnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryListstyle__ColumnWrapper",
  componentId: "sc-10iz6l5-2"
})(["display:flex;flex-direction:column;& > span{margin-bottom:-6px;}"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalV2.style.tsx
var SelectCountryModalV2_style = __webpack_require__(87794);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/CountryList.tsx
//TODO: Check and Remove Duplicate components in this file and libs/insurance-landing-ui/src/lib/components (Present for Landing Page Components)

















const CountryList = ({
  countryData,
  countryHandler,
  isCheckedHandler,
  setCountryData,
  searchQueryHighlighter,
  setIsSelectedError,
  showHeader,
  setCountrySelectToastMsg,
  customHeight = 380
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)(); //TODO: handle default cell height using css var

  const defaultCellHeight = 57; //TODO: Check alternate height calculation using DOM elements

  const windowHeight = window.innerHeight - 213;
  const windowWidth = window.innerWidth - 60;
  const listRef = (0,react.useRef)(null);
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  const {
    0: showViewAllButton,
    1: setShowViewAllButton
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const temp = countryData.map(data => {
      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  }, []);
  (0,react.useEffect)(() => {
    listRef?.current?.resetAfterIndex(0);
  }, [countryData]);

  const handleDescription = code => {
    const data = countryData.filter(data => data?.code === code)[0];

    if (data.showExpandedDescription || data.description.length < 80) {
      setShowViewAllButton(false);
      console.log(data.description.length);
      return data.description;
    }

    setShowViewAllButton(true);
    const tempDescData = data.description.substring(0, 80).split(" ");
    tempDescData.pop();
    const descData = tempDescData.join(" ") + "...";
    return descData;
  };

  const handleRegionDescription = code => {
    let temp = countryData.map(data => {
      if (data.code === code && !data.showDescription) {
        data["showDescription"] = true;
        data["showExpandedDescription"] = false;
        return data;
      }

      data["showDescription"] = false;
      data["showExpandedDescription"] = false;
      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  };

  const handleErrorToast = (0,utils/* debounce */.Ds)(() => {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  const handleCountrySelectError = country => {
    const isExclusiveCountrySelected = countryData.find(item => item.isExclusiveSelection && item.isSelected);

    if (isExclusiveCountrySelected && !country?.isExclusiveSelection && country.isDisabled) {
      setCountrySelectToastMsg("Selected country cannot be chosen for domestic coverage");
      handleErrorToast();
    } else if (country?.isExclusiveSelection && !isExclusiveCountrySelected && country.isDisabled) {
      setCountrySelectToastMsg("India cannot be chosen for International Travel");
      handleErrorToast();
    } else if (country.isDisabled) {
      setIsSelectedError(true);
      handleErrorToast();
    } else {
      {
        !country.isSelected && !country.showDescription && handleRegionDescription(country.code);
      }
      {
        country.isSelected && country.showDescription && handleRegionDescription(country.code);
      }
      countryHandler(country.code);
    }
  };

  const handleViewAll = code => {
    let temp = countryData.map(data => {
      if (data.code === code) {
        data["showExpandedDescription"] = !data["showExpandedDescription"];
      }

      return data;
    });
    listRef?.current?.resetAfterIndex(0);
    setCountryData(temp);
  }; //TODO: optimise logic for isExclusiveCountrySelected


  const checkGreyOut = item => {
    const isExclusiveCountrySelected = !!countryData.find(item => item.isExclusiveSelection && item.isSelected);

    if (isExclusiveCountrySelected && !item?.isExclusiveSelection && item.isDisabled) {
      return true;
    }

    if (item?.isExclusiveSelection && !isExclusiveCountrySelected && item.isDisabled) {
      return true;
    }

    return false;
  };

  const rowRenderer = ({
    index,
    key
  }) => {
    const item = countryData?.[index];

    if (!item) {
      return null; // Return null if item is undefined
    } else if (item.type === "HEADER") {
      return showHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalV2_style/* CountryItem */.wh, {
        disableCursor: true,
        margin: device === "lg" ? "0px 17px 0px 0px" : "",
        "data-test-id": "CountryList-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: item.name,
          baseStyle: {
            fontWeight: "bold",
            fontSize: "14px"
          },
          "data-test-id": "CountryList-rowRenderer-FormattedText"
        })
      });
    } else if (item.code) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        "data-test-id": `CountryList-rowRenderer-${key}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectCountryModalV2_style/* CountryItem */.wh, {
          disableCursor: true,
          margin: device === "lg" ? "0px 17px 0px 0px" : "",
          "data-test-id": "CountryList-rowRenderer-CountryItem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
            "data-test-id": "CountryList-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CheckButton/* default */.Z, {
              handleChange: () => handleCountrySelectError(item),
              isChecked: item.isDisabled ? true : isCheckedHandler(item),
              isDisabled: item.isDisabled,
              greyOut: checkGreyOut(item),
              "data-test-id": "CountryList-rowRenderer-CheckButton",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
                handleClick: () => handleCountrySelectError(item),
                alignItems: "center",
                justifyContent: "space-between",
                "data-test-id": "CountryList-rowRenderer-FlexComp",
                children: [item.subtitle ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ColumnWrapper, {
                  "data-test-id": "CountryList-rowRenderer-ColumnWrapper",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: searchQueryHighlighter(item.name)
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                    "data-test-id": "CountryList-rowRenderer-SpanTag",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                      value: item.subtitle,
                      baseStyle: {
                        fontSize: "12px",
                        fontWeight: "400"
                      },
                      "data-test-id": "CountryList-rowRenderer-FormattedText"
                    })
                  })]
                }) : searchQueryHighlighter(item.name), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                  value: item.countryCount,
                  baseStyle: {
                    padding: "0px 10px 0px 0px",
                    fontSize: "12px",
                    color: "#4A4A4A"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                  value: item.regionName,
                  baseStyle: {
                    fontSize: "12px",
                    color: "#0000004D"
                  },
                  "data-test-id": "CountryList-rowRenderer-FormattedText"
                })]
              })
            }), item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButtonWrap, {
              onClick: () => {
                handleRegionDescription(item.code);
              },
              "data-test-id": "CountryList-rowRenderer-ArrowButtonWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
                width: "9px",
                height: "9px",
                margin: "0px 0px 0px 0px",
                src: item.showDescription ? context === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Right_Arrow_b9b5e073fa.png" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg" : context === src.PARTNER.MYBIZ ? "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_f3475d8184.png" : "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                "data-test-id": "CountryList-rowRenderer-ImageComponent"
              })
            })]
          }), item.showDescription && item.type === "REGION" && /*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionWrap, {
            "data-test-id": "CountryList-rowRenderer-DescriptionWrap",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: item.descTitle,
              baseStyle: {
                fontWeight: "bold",
                fontSize: "14px"
              },
              "data-test-id": "CountryList-rowRenderer-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: handleDescription(item.code),
                baseStyle: {
                  fontSize: "14px"
                },
                "data-test-id": "CountryList-rowRenderer-FormattedText"
              })
            }), showViewAllButton && /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorTag/* default */.Z, {
              handleClick: () => {
                handleViewAll(item.code);
              },
              fontWeight: "bold",
              color: "var(--tm-accent-color)",
              "data-test-id": "CountryList-rowRenderer-AnchorTag",
              children: "View All"
            })]
          })]
        })
      }, key);
    }

    return;
  };

  const getItemSize = (code, isShowDesc, isShowAllDesc) => {
    let expansionValue = 0;

    if (isShowAllDesc) {
      expansionValue = 2;
    } else if (isShowDesc) {
      expansionValue = 1;
    }

    return (0,utils/* interpolateRowHeight */.IS)(device === "lg" ? 360 : windowWidth, code, expansionValue) || defaultCellHeight;
  };

  const getItemSizes = index => {
    const height = countryData[index].type === "REGION" ? getItemSize(countryData[index].code, countryData[index].showDescription, countryData[index].showExpandedDescription) : defaultCellHeight;
    return height;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* VariableSizeList */.S_, {
    height: device === "lg" ? customHeight : windowHeight,
    itemCount: countryData.length,
    itemSize: getItemSizes,
    width: device === "lg" ? 360 : windowWidth,
    ref: listRef,
    "data-test-id": "CountryList-FixList",
    children: ({
      index,
      style
    }) => {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: style,
        "data-test-id": `CountryList-${index}`,
        children: rowRenderer({
          index,
          key: index
        })
      }, index);
    }
  });
};

/* harmony default export */ const SelectCountryModal_CountryList = (CountryList);

/***/ }),

/***/ 57748:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ SelectCountryModal_SelectCountryCodeModal)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CheckButton/CheckButton.style.ts
var CheckButton_style = __webpack_require__(10569);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.style.ts
var CommonModalDweb_style = __webpack_require__(39881);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.style.ts
var LandingButton_style = __webpack_require__(45590);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TMFloatingInput/TMFloatingInput.style.ts
var TMFloatingInput_style = __webpack_require__(40599);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ToolTipComp/ToolTipComp.style.ts
var ToolTipComp_style = __webpack_require__(45874);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModal.style.ts








const SelectCountryModalStyle = (0,styled_components_browser_esm/* default */.ZP)(CommonModalDweb_style/* CommonModalDwebStyle */.E5).withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryModalStyle",
  componentId: "one95n-0"
})([".ReactVirtualized__Grid .ReactVirtualized__List{width:100%;}"]);
const CountryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountryItem",
  componentId: "one95n-1"
})(["border-bottom:1px solid #e8e8e8;padding:18px 0;position:relative;cursor:pointer;", "{position:absolute;bottom:16px;left:16px;}", "{width:100%;}.highlight{background-color:", ";}", "{position:fixed;}"], LandingButton_style/* LandingButtonStyle */.zm, CheckButton_style/* CheckButtonStyle */.m, Global/* theme.yellowText3 */.rS.yellowText3, ToolTipComp_style/* ToolTipCompWrapper */.V);
const BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__BtnWrap",
  componentId: "one95n-2"
})(["position:sticky;bottom:16px;left:16px;width:calc(100% - 32px);"]);
const CountrySection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySection",
  componentId: "one95n-3"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e8e8e8;padding:12px 0;"]);
const CountrySectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__CountrySectionWrap",
  componentId: "one95n-4"
})(["overflow-y:scroll;@media ", "{padding:16px;}"], src.deviceType.mobile);
const PopularRegionCountries = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__PopularRegionCountries",
  componentId: "one95n-5"
})(["border-radius:4px;background:#f6f6f6;padding:12px;margin-top:12px;"]);
const SelectCountrySheetStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountrySheetStyle",
  componentId: "one95n-6"
})(["display:flex;flex-direction:column;height:100vh;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#fff;", "{position:sticky;top:0px;z-index:1;width:calc(100% - 32px);left:16px;padding-top:16px;}"], TMFloatingInput_style/* TMInputWrap */.dd);
const SelectCountryHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryModalstyle__SelectCountryHeader",
  componentId: "one95n-7"
})(["position:sticky;top:0;display:flex;gap:16px;align-items:center;padding:16px;z-index:1;background:#fff;left:-16px;right:-16px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);"]);
// EXTERNAL MODULE: ../../node_modules/react-virtualized/dist/es/index.js + 34 modules
var es = __webpack_require__(37863);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryCodeModal.tsx









const SelectCountryCodeModal = ({
  countryData,
  handleSelectCountry,
  handleClose
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const windowWidth = window.innerWidth - 60;
  const {
    0: countriesData,
    1: setCountriesData
  } = (0,react.useState)(countryData);
  const {
    0: searchTxt,
    1: setInputValue
  } = (0,react.useState)("");
  const rowHeight = 60;

  const calculateListHeight = () => {
    const rowCount = countriesData?.length ?? 0; // Replace with your actual data length

    const height = rowCount * rowHeight;
    return height;
  };

  const countryHandler = id => {
    if (id) {
      setCountriesData(countryData?.map(item => {
        if (id === item.id) {
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }

        return item;
      }));
    }
  };

  (0,react.useEffect)(() => {
    if (searchTxt?.length) {
      const filteredDataList = searchTxt ? countryData?.filter(items => items.countryName?.toLowerCase().includes(searchTxt.toLowerCase())) : countryData;
      setCountriesData(filteredDataList);
    }
  }, [searchTxt]);

  const rowRenderer = ({
    index,
    key
  }) => {
    const item = countriesData && countriesData[index];

    if (!item) {
      return null; // Return null if item is undefined
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-test-id": `SelectCountryCodeModal-rowRenderer-${key}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CountryItem, {
        onClick: () => countryHandler(item.id),
        "data-test-id": "SelectCountryCodeModal-rowRenderer-CountryItem",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.RadioButton, {
          handleChange: () => countryHandler(item.id),
          activeBtn: item.isSelected,
          "data-test-id": "SelectCountryCodeModal-rowRenderer-RadioButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              alignItems: "center",
              gap: "8px",
              "data-test-id": "SelectCountryCodeModal-rowRenderer-FlexComp",
              children: [item.countryFlag && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                src: item.countryFlag,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                fontSize: "sm",
                color: Global/* theme.blackText */.rS.blackText,
                "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
                children: item.countryName
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontWeight: "bold",
              fontSize: "xs",
              color: Global/* theme.blackText */.rS.blackText,
              "data-test-id": "SelectCountryCodeModal-rowRenderer-SpanTag",
              children: item.countryCode
            })]
          })
        })
      })
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.CommonModalDweb, {
    handleClick: handleClose,
    customTitle: "Select Country",
    "data-test-id": "SelectCountryCodeModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.TMFloatingInput, {
      handleChange: e => setInputValue(e.target.value),
      inputValue: searchTxt,
      labelTxt: "Search Country Name",
      "data-test-id": "SelectCountryCodeModal-TMFloatingInput"
    }), countriesData?.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(CountrySection, {
      "data-test-id": "SelectCountryCodeModal-CountrySection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Country Name"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "sm",
        fontWeight: "bold",
        "data-test-id": "SelectCountryCodeModal-SpanTag",
        children: "Code"
      })]
    }), countriesData && countriesData?.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(es/* List */.aV, {
      width: device === "lg" ? 360 : windowWidth,
      height: calculateListHeight(),
      style: {
        minHeight: calculateListHeight()
      },
      autoHeight: true,
      rowHeight: rowHeight,
      rowCount: countriesData.length,
      rowRenderer: rowRenderer,
      "data-test-id": "SelectCountryCodeModal-List"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      fontSize: "sm",
      color: Global/* theme.greyText */.rS.greyText,
      margin: "16px 0 16px",
      "data-test-id": "SelectCountryCodeModal-ParaTag",
      children: "No Country Found! Please enter correct name"
    }), countriesData?.length != 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(BtnWrap, {
      "data-test-id": "SelectCountryCodeModal-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        customWidth: "100%",
        customTitle: "Select",
        onClick: () => handleSelectCountry(countriesData),
        "data-test-id": "SelectCountryCodeModal-LandingButton"
      })
    })]
  });
};

/* harmony default export */ const SelectCountryModal_SelectCountryCodeModal = (SelectCountryCodeModal);

/***/ }),

/***/ 76409:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2182);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62663);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48359);
/* harmony import */ var _tm_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76609);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42874);
/* harmony import */ var fuse_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89325);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2784);
/* harmony import */ var _Toast_WebToast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78891);
/* harmony import */ var _CountryList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68003);
/* harmony import */ var _tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50354);
/* harmony import */ var _SelectCountryModalV2_style__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87794);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_1__/* .getAnalytics */ .I)();
const DEBOUNCE_TIME = 300;

const fuzzySearch = (searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) => {
  const selectedCountriesData = displayCountryData.filter(country => country.isSelected && !country.isDisabled);
  const searchResults = searcher.search(searchValue);
  const filteredData = searchResults?.map(match => match?.item);
  const originalSortData = countryData.map(country => {
    return displayCountryData.find(item => item.code === country.code);
  });
  const allObjects = [...selectedCountriesData, ...filteredData, ...originalSortData];
  const tempObj = allObjects.reduce((acc, obj) => {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  const uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

const debouncedSearch = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__/* .debounce */ .Ds)(fuzzySearch, 300);

const SelectCountryModalSheet = ({
  handleSelectCountry,
  countryData,
  setShowCountry,
  setCountryData,
  showCountry,
  countrySelectErrMsg,
  setIsCountryError,
  popularCountries,
  setPopularCountries,
  handleDescriptionModal,
  customSubTitle
}) => {
  const {
    0: displayCountryData,
    1: setDisplayCountrysData
  } = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(countryData);
  const {
    0: searchTxt,
    1: setSearchTxt
  } = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("");
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false);
  const searchedCountriesOmn = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)([]);
  const selectedCountriesOmn = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)([]);
  const singleSearchSelection = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(false);
  const {
    0: countrySelectToastMsg,
    1: setCountrySelectToastMsg
  } = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("");
  const {
    type
  } = (0,_tm_ui__WEBPACK_IMPORTED_MODULE_4__/* .usePlanType */ .U)();
  const searcher = new fuse_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  const noSearchResults = addTimeOut => {
    let allObjects = [];
    const selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    const selectedCountriesData = displayCountryData.filter(country => {
      return country.isSelected && !country.isDisabled;
    });
    const originalSortData = countryData.map(country => {
      return displayCountryData.find(item => item.code === country.code);
    });

    if (selectedCountriesData.length) {
      allObjects = [_objectSpread({}, selectedHeader), ...selectedCountriesData, ...originalSortData];
      const tempObj = allObjects.reduce((acc, obj) => {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      const uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(uniqueObjects);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(originalSortData);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    noSearchResults(false);
    analytics?.trackLandingEvents({
      actionType: `Ins_Country_popuploaded`
    }, "pageView", type);
    (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_10__.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "popup-rendered",
        event_value: `Ins_Country_popuploaded`
      }
    });
  }, []);

  const countryClickHandler = code => {
    handleDescriptionModal(displayCountryData.filter(data => data.code === code)[0]);
    let updatedCountryArr = displayCountryData?.map(country => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return _objectSpread({}, country);
        }
        /* istanbul ignore next */


        if (selectedCountriesOmn?.current?.length >= 30) {
          selectedCountriesOmn.current = [...selectedCountriesOmn?.current?.slice(1), country.code];
        } else {
          selectedCountriesOmn.current = [...selectedCountriesOmn?.current, country.code];
        }

        analytics?.trackLandingEvents({
          actionType: `Ins_Country_popup_checkbox:${country.name}`
        }, "pageView", type);
        (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_10__.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: `Ins_Country_popup_checkbox:${country.name}`
          }
        });
        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return _objectSpread(_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    const isExclusiveCountrySelected = updatedCountryArr.find(item => item.isExclusiveSelection && item.isSelected);
    updatedCountryArr = updatedCountryArr.map(country => {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? _objectSpread({}, country) : _objectSpread(_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
          isDisabled: true
        }) : _objectSpread({}, country);
      }

      return _objectSpread({}, country);
    });
    const selectedCountryCodes = updatedCountryArr.filter(country => country.isSelected && country.type === "REGION").map(country => {
      return country.code;
    });
    selectedCountryCodes.map(item => {
      updatedCountryArr = updatedCountryArr.map(country => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return _objectSpread({}, country);
      });
    });
    setDisplayCountrysData(updatedCountryArr);
    const popularCountryData = updatedCountryArr.filter(country => country.isSelected || country.isPopular);
    setPopularCountries([...popularCountryData.filter(country => country.isSelected && !country.isDisabled), ...popularCountryData.filter(country => country.isDisabled), ...popularCountryData.filter(country => !country.isSelected && !country.isDisabled)]);
  };

  const handleSearchtxt = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(searchValue => {
    debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  const onSearchChange = searchValue => {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  const searchQueryHighlighter = ele => {
    const withSpecialCharsSupport = searchTxt?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const searchRegex = new RegExp(`(${withSpecialCharsSupport})`, "ig");
    const highlighted = ele.replace(searchRegex, match => `<span class="highlight">${match}</span>`);
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModalSheet-searchQueryHighlighter-ParaTag"
    });
  };

  const isCheckedHandler = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(data => {
    return data.isSelected;
  }, [displayCountryData, searchTxt]);

  const handleCrossClick = () => {
    setPopularCountries(showCountry);

    if (searchedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      }, "pageView", type);
      searchedCountriesOmn.current = [];
    }

    let tempCountryData = displayCountryData.map(country => {
      return _objectSpread(_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    showCountry.map(data => {
      tempCountryData = tempCountryData.map(country => {
        if (data.code === country.code) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return _objectSpread({}, country);
      });
    });
    setDisplayCountrysData(_objectSpread({}, tempCountryData));
    handleSelectCountry();
  };

  const onCountrySubmit = () => {
    analytics?.trackLandingEvents({
      actionType: "Ins_Country_popup_AddDestinationClicked"
    }, "pageView", type);
    (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_10__.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "Ins_Country_popup_AddDestinationClicked"
      }
    });
    setIsCountryError(false);

    if (searchedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      }, "pageView", type);
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn?.current?.join("|")
      }, "pageView", type);
      selectedCountriesOmn.current = [];
    }

    let countryDataArr = countryData.map(country => {
      return _objectSpread(_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(data => {
      countryDataArr = countryDataArr.map(country => {
        if (country.code === data.code) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return _objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    const selectedCountryCodes = displayCountryData.filter(item => item.isSelected && !item.isDisabled).map(item => item.code);
    (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__/* .replaceHistoryRemoveParams */ ._A)("countries");
    (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__/* .replaceHistory */ .df)("countries", selectedCountryCodes.join(","));
    const selectedNonPopCountries = displayCountryData.filter(data => data.isSelected && !data.isPopular);
    analytics?.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(c => c.name).join("|")
    }, "pageView", type); // trackEvent({
    //   event_detail: {
    //     event_type: "action",
    //     event_name: "component_cta-clicked",
    //     event_value: "other_countries_clicked",
    //   },
    // });

    handleSelectCountry && handleSelectCountry();
  };

  const handleSearchTxt = event => {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      if (searchedCountriesOmn?.current?.length >= 30) {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current?.slice(1), searchTxt];
      } else {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current, searchTxt];
      }
    }

    setSearchTxt(_ => event.target.value);
    onSearchChange(event.target.value);
  };

  const searchClickAnalytics = () => {
    analytics?.trackLandingEvents({
      actionType: "Ins_Country_popup_searchclicked"
    }, "pageView", type);

    if (!singleSearchSelection.current) {
      singleSearchSelection.current = true;
      (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_10__.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "Ins_Country_popup_searchclicked"
        }
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ReactPortalComp, {
    "data-test-id": "SelectCountryModalSheet-ReactPortalComp",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_SelectCountryModalV2_style__WEBPACK_IMPORTED_MODULE_11__/* .SelectCountrySheetStyle */ .NQ, {
      "data-test-id": "SelectCountryModalSheet-SelectCountrySheetStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_SelectCountryModalV2_style__WEBPACK_IMPORTED_MODULE_11__/* .SelectCountryHeader */ .v0, {
        "data-test-id": "SelectCountryModalSheet-SelectCountryHeader",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.AnchorTag, {
          handleClick: handleCrossClick,
          "data-test-id": "SelectCountryModalSheet-AnchorTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("path", {
              d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
              fill: "#808080"
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FlexComp, {
          flexDirection: "column",
          "data-test-id": "SelectCountryModalSheet-FlexComp",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
            fontSize: "md",
            fontWeight: "bold",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_5__/* .theme.greyText */ .rS.greyText,
            "data-test-id": "SelectCountryModalSheet-ParaTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
              value: "Select Destinations",
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
            fontSize: "xs",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_5__/* .theme.greyText6 */ .rS.greyText6,
            "data-test-id": "SelectCountryModalSheet-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
              value: customSubTitle,
              "data-test-id": "SelectCountryModalSheet-FormattedText"
            })
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        onClick: searchClickAnalytics,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.TMFloatingInput, {
          handleChange: e => handleSearchTxt(e),
          inputValue: searchTxt,
          labelTxt: "Search Country/Region",
          "data-test-id": "SelectCountryModalSheet-TMFloatingInput"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_SelectCountryModalV2_style__WEBPACK_IMPORTED_MODULE_11__/* .CountrySectionWrap */ .pg, {
        "data-test-id": "SelectCountryModalSheet-CountrySectionWrap",
        children: displayCountryData?.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_CountryList__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          countryData: searchTxt.length ? displayCountryData.filter(country => country.type !== "HEADER") : displayCountryData,
          countryHandler: countryClickHandler,
          isCheckedHandler: isCheckedHandler,
          searchQueryHighlighter: searchQueryHighlighter,
          setCountryData: setDisplayCountrysData,
          setIsSelectedError: setIsSelectedError,
          showHeader: !searchTxt.length,
          setCountrySelectToastMsg: setCountrySelectToastMsg,
          "data-test-id": "SelectCountryModalSheet-CountryList"
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
          fontSize: "sm",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_5__/* .theme.greyText */ .rS.greyText,
          margin: "30px 0px 0px 0px",
          "data-test-id": "SelectCountryModalSheet-ParaTag",
          children: "No Country Found! Please enter correct name"
        })
      }), isSelectedError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_Toast_WebToast__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        toastTxt: countrySelectErrMsg,
        position: "fixed",
        height: "40px",
        bottom: "75px",
        "data-test-id": "SelectCountryModalSheet-WebToast"
      }), displayCountryData?.length && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_SelectCountryModalV2_style__WEBPACK_IMPORTED_MODULE_11__/* .BtnWrap */ .Kj, {
        position: "fixed",
        bottom: "0px",
        background: "white",
        "data-test-id": "SelectCountryModalSheet-BtnWrap",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.LandingButton, {
          margin: "12px 16px 12px 16px",
          customWidth: "92%",
          customTitle: "Add Destination",
          onClick: onCountrySubmit,
          "data-test-id": "SelectCountryModalSheet-LandingButton"
        })
      })]
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SelectCountryModalSheet);

/***/ }),

/***/ 87794:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kj": () => (/* binding */ BtnWrap),
/* harmony export */   "NQ": () => (/* binding */ SelectCountrySheetStyle),
/* harmony export */   "pg": () => (/* binding */ CountrySectionWrap),
/* harmony export */   "v0": () => (/* binding */ SelectCountryHeader),
/* harmony export */   "wh": () => (/* binding */ CountryItem)
/* harmony export */ });
/* unused harmony exports SelectCountryModalStyle, CountrySection, PopularRegionCountries */
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44928);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);
/* harmony import */ var _CheckButton_CheckButton_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10569);
/* harmony import */ var _CommonModalDweb_CommonModalDweb_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39881);
/* harmony import */ var _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45590);
/* harmony import */ var _TMFloatingInput_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40599);
/* harmony import */ var _ToolTipComp_ToolTipComp_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45874);








const SelectCountryModalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_CommonModalDweb_CommonModalDweb_style__WEBPACK_IMPORTED_MODULE_4__/* .CommonModalDwebStyle */ .E5).withConfig({
  displayName: "SelectCountryModalV2style__SelectCountryModalStyle",
  componentId: "sc-2hn0ay-0"
})([".ReactVirtualized__Grid .ReactVirtualized__List{width:100%;}"]);
const CountryItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__CountryItem",
  componentId: "sc-2hn0ay-1"
})(["border-bottom:1px solid #e8e8e8;padding:18px 0;position:relative;margin:", ";cursor:", ";", "{position:absolute;bottom:16px;left:16px;}", "{width:100%;}.highlight{background-color:", ";}", "{position:fixed;}"], props => props.margin && `${props.margin}`, props => props.disableCursor ? "default" : "pointer", _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_5__/* .LandingButtonStyle */ .zm, _CheckButton_CheckButton_style__WEBPACK_IMPORTED_MODULE_3__/* .CheckButtonStyle */ .m, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.yellowText3 */ .rS.yellowText3, _ToolTipComp_ToolTipComp_style__WEBPACK_IMPORTED_MODULE_7__/* .ToolTipCompWrapper */ .V);
const BtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__BtnWrap",
  componentId: "sc-2hn0ay-2"
})(["position:", ";", ";", ";width:100%;"], props => props.position ? `${props.position}` : `sticky`, props => props.bottom && `bottom:${props.bottom}`, props => props.background && `background:${props.background}`);
const CountrySection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__CountrySection",
  componentId: "sc-2hn0ay-3"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e8e8e8;padding:12px 0;"]);
const CountrySectionWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__CountrySectionWrap",
  componentId: "sc-2hn0ay-4"
})(["@media ", "{padding:16px 16px 70px 16px;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);
const PopularRegionCountries = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__PopularRegionCountries",
  componentId: "sc-2hn0ay-5"
})(["border-radius:4px;background:#f6f6f6;padding:12px;margin-top:12px;"]);
const SelectCountrySheetStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__SelectCountrySheetStyle",
  componentId: "sc-2hn0ay-6"
})(["display:flex;flex-direction:column;height:100vh;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#fff;", "{position:sticky;top:0px;z-index:1;width:calc(100% - 32px);left:16px;padding-top:16px;}"], _TMFloatingInput_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_6__/* .TMInputWrap */ .dd);
const SelectCountryHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SelectCountryModalV2style__SelectCountryHeader",
  componentId: "sc-2hn0ay-7"
})(["position:sticky;top:0;display:flex;gap:16px;align-items:center;padding:16px;z-index:1;background:#fff;left:-16px;right:-16px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);"]);

/***/ }),

/***/ 38051:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ SelectCountryModal_SelectCountryModalV2)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/fuse.js/dist/fuse.mjs
var fuse = __webpack_require__(89325);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionCountryModal.tsx + 1 modules
var RegionCountryModal = __webpack_require__(94884);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.tsx + 1 modules
var WebToast = __webpack_require__(78891);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/CountryList.tsx + 1 modules
var CountryList = __webpack_require__(68003);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryDropdown.style.ts


const DropdownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryDropdownstyle__DropdownContainer",
  componentId: "sc-17uqbu3-0"
})(["position:relative;top:-70px;width:100%;"]);
const DropdownContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryDropdownstyle__DropdownContent",
  componentId: "sc-17uqbu3-1"
})(["position:absolute;top:100%;left:0;right:0;background:white;border:1px solid #e0e0e0;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.15);z-index:1000;max-height:490px;overflow-y:auto;margin-top:4px;display:flex;flex-direction:column;"]);
const StickySearchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryDropdownstyle__StickySearchContainer",
  componentId: "sc-17uqbu3-2"
})(["position:sticky;top:0;background:white;z-index:10;box-shadow:0px 2px 3px 0px #0000001a;"]);
const StickyButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryDropdownstyle__StickyButtonContainer",
  componentId: "sc-17uqbu3-3"
})(["position:sticky;bottom:0;background:white;z-index:10;box-shadow:0px 1px 6px 0px #00000033;display:flex;flex-direction:row-reverse;padding:8px 16px;button{border-radius:38px;}"]);
const ScrollableContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryDropdownstyle__ScrollableContent",
  componentId: "sc-17uqbu3-4"
})(["flex:1;padding:0 16px;"]);
const InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SelectCountryDropdownstyle__InputWrapper",
  componentId: "sc-17uqbu3-5"
})(["font-size:", ";display:flex;align-items:center;background:", ";padding:0 12px;box-shadow:0px 1px 2px 0px rgba(0,0,0,0.05);height:44px;"], Global/* fontSize.font14 */.JB.font14, Global/* theme.whiteText */.rS.whiteText);
const InputIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "SelectCountryDropdownstyle__InputIcon",
  componentId: "sc-17uqbu3-6"
})(["font-size:", ";color:", ";margin-right:8px;display:flex;align-items:center;"], Global/* fontSize.font20 */.JB.font20, Global/* theme.greyText2 */.rS.greyText2);
const CountryInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "SelectCountryDropdownstyle__CountryInput",
  componentId: "sc-17uqbu3-7"
})(["border:none;background:transparent;outline:none;font-size:", ";flex:1;color:", ";height:40px;"], Global/* fontSize.font16 */.JB.font16, Global/* theme.blackText2 */.rS.blackText2);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalV2.style.tsx
var SelectCountryModalV2_style = __webpack_require__(87794);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalV2.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















const analytics = (0,insurance/* getAnalytics */.I)();
const DEBOUNCE_TIME = 300;

const fuzzySearch = (searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData) => {
  const selectedCountriesData = displayCountryData.filter(country => country.isSelected && !country.isDisabled);
  const searchResults = searcher.search(searchValue);
  const filteredData = searchResults?.map(match => match?.item);
  const originalSortData = countryData.map(country => {
    return displayCountryData.find(item => item.code === country.code);
  });
  const allObjects = [...selectedCountriesData, ...filteredData, ...originalSortData];
  const tempObj = allObjects.reduce((acc, obj) => {
    if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
      acc[obj.code] = obj;
    }

    return acc;
  }, {});
  const uniqueObjects = Object.values(tempObj);
  setDisplayCountrysData(uniqueObjects);
};

const debouncedSearch = (0,utils/* debounce */.Ds)(fuzzySearch, DEBOUNCE_TIME);

const SelectCountryModalV2 = ({
  handleSelectCountry,
  countryData,
  setShowCountry,
  showCountry,
  setCountryData,
  countrySelectErrMsg,
  setIsCountryError,
  popularCountries,
  setPopularCountries,
  customSubTitle,
  handleDescriptionModal,
  focusSearchOnOpen = false,
  isDropdown = false,
  travelNameRef
}) => {
  const {
    0: displayCountryData,
    1: setDisplayCountrysData
  } = (0,react.useState)(countryData);
  const {
    0: searchTxt,
    1: setSearchTxt
  } = (0,react.useState)("");
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const {
    0: countrySelectToastMsg,
    1: setCountrySelectToastMsg
  } = (0,react.useState)("");
  const searchedCountriesOmn = (0,react.useRef)([]);
  const selectedCountriesOmn = (0,react.useRef)([]);
  const singleSearchSelection = (0,react.useRef)(false);
  const dropdownRef = (0,react.useRef)(null);
  const {
    type
  } = (0,src/* usePlanType */.U)();
  const searcher = new fuse/* default */.Z(displayCountryData, {
    keys: ["name", "keywords", "regionName", "description", "code", "regionCodes"],
    isCaseSensitive: false,
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.5,
    minMatchCharLength: 1
  });

  const noSearchResults = addTimeOut => {
    let allObjects = [];
    const selectedHeader = {
      type: "HEADER",
      name: "Selected Countries",
      code: "SELECTED_COUNTRIES"
    };
    const selectedCountriesData = displayCountryData.filter(country => {
      return country.isSelected && !country.isDisabled;
    });
    const originalSortData = countryData.map(country => {
      return displayCountryData.find(item => item.code === country.code);
    });

    if (selectedCountriesData.length) {
      allObjects = [_objectSpread({}, selectedHeader), ...selectedCountriesData, ...originalSortData];
      const tempObj = allObjects.reduce((acc, obj) => {
        if (obj && obj.code && !acc.hasOwnProperty(obj.code)) {
          acc[obj.code] = obj;
        }

        return acc;
      }, {});
      const uniqueObjects = Object.values(tempObj);
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(uniqueObjects);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(uniqueObjects);
    } else {
      addTimeOut ? setTimeout(() => {
        setDisplayCountrysData(originalSortData);
      }, DEBOUNCE_TIME) : setDisplayCountrysData(originalSortData);
    }
  };

  (0,react.useEffect)(() => {
    noSearchResults(false);
    analytics?.trackLandingEvents({
      actionType: `Ins_Country_popuploaded`
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "popup-rendered",
        event_value: `Ins_Country_popuploaded`
      }
    });
  }, []);
  (0,react.useEffect)(() => {
    const handleClickOutside = event => {
      if (isDropdown && dropdownRef.current && !dropdownRef.current.contains(event.target) && travelNameRef?.current && !travelNameRef?.current?.contains(event.target)) {
        onCountrySubmit();
        event.stopPropagation();
      }
    };

    if (isDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdown, travelNameRef, displayCountryData, countryData, popularCountries]);

  const countryClickHandler = code => {
    handleDescriptionModal(displayCountryData.filter(data => data.code === code)[0]);
    let selected = "";
    let updatedCountryArr = displayCountryData?.map(country => {
      if (country.code === code) {
        if (country["isSelected"]) {
          country["isSelected"] = false;
          return _objectSpread({}, country);
        }
        /* istanbul ignore next */


        if (selectedCountriesOmn?.current?.length >= 30) {
          selectedCountriesOmn.current = [...selectedCountriesOmn?.current?.slice(1), country.code];
        } else {
          selectedCountriesOmn.current = [...selectedCountriesOmn.current, country.code];
        }

        analytics?.trackLandingEvents({
          actionType: `Ins_Country_popup_checkbox:${country.name}`
        }, "pageView", type);
        selected = country?.name || "";
        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: true,
          isDisabled: false
        });
      }

      return _objectSpread(_objectSpread({}, country), {}, {
        isDisabled: false
      });
    });
    const isExclusiveCountrySelected = updatedCountryArr.find(item => item.isExclusiveSelection && item.isSelected);
    updatedCountryArr = updatedCountryArr.map(country => {
      if (isExclusiveCountrySelected) {
        return country.isExclusiveSelection ? _objectSpread({}, country) : _objectSpread(_objectSpread({}, country), {}, {
          isSelected: false,
          isDisabled: true
        });
      } else if (updatedCountryArr.some(item => item.isSelected)) {
        return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
          isDisabled: true
        }) : _objectSpread({}, country);
      }

      return _objectSpread({}, country);
    });
    const selectedCountryCodes = updatedCountryArr.filter(country => country.isSelected && country.type === "REGION").map(country => {
      return country.code;
    });
    selectedCountryCodes.map(item => {
      updatedCountryArr = updatedCountryArr.map(country => {
        if (country.regionCodes && country.regionCodes.includes(item)) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          });
        }

        return _objectSpread({}, country);
      });
    });
    const selectedCountries = updatedCountryArr.filter(country => country.isSelected && !country.isDisabled);

    if (selected) {
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: `Ins_Country_popup_checkbox:${selected}`
        }
      }, {
        countries: selectedCountries
      });
    } else {
      (0,XDMAnalytics.updateSearchContext)({
        countries: selectedCountries
      });
    }

    setDisplayCountrysData(updatedCountryArr);
    const popularCountryData = updatedCountryArr.filter(country => country.isSelected || country.isPopular);
    setPopularCountries([...popularCountryData.filter(country => country.isSelected && !country.isDisabled), ...popularCountryData.filter(country => country.isDisabled), ...popularCountryData.filter(country => !country.isSelected && !country.isDisabled)]);
  };

  const handleSearchtxt = (0,react.useCallback)(searchValue => {
    debouncedSearch(searcher, searchValue, displayCountryData, countryData, setDisplayCountrysData);
  }, [displayCountryData]);

  const onSearchChange = searchValue => {
    if (searchValue) {
      handleSearchtxt(searchValue);
    } else {
      noSearchResults(true);
    }
  };

  const searchQueryHighlighter = ele => {
    const withSpecialCharsSupport = searchTxt?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const searchRegex = new RegExp(`(${withSpecialCharsSupport})`, "ig");
    const highlighted = ele.replace(searchRegex, match => `<span class="highlight">${match}</span>`);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      dangerousText: highlighted,
      "data-test-id": "SelectCountryModalV2-searchQueryHighlighter-ParaTag"
    });
  };

  const isCheckedHandler = (0,react.useCallback)(data => {
    return data.isSelected;
  }, [displayCountryData, searchTxt]); // const handleCrossClick = () => {
  //   setPopularCountries(showCountry);
  //   if (searchedCountriesOmn?.current?.length) {
  //     analytics?.trackLandingEvents(
  //       {
  //         actionType: "searched_countries",
  //         payload: searchedCountriesOmn?.current?.join("|") + "|",
  //       },
  //       "pageView",
  //       type
  //     );
  //     searchedCountriesOmn.current = [];
  //   }
  //   let tempCountryData: any = displayCountryData.map((country: any) => {
  //     return { ...country, isSelected: false, isDisabled: false };
  //   });
  //   showCountry.map((data: any) => {
  //     tempCountryData = tempCountryData.map((country: any) => {
  //       if (data.code === country.code) {
  //         return {
  //           ...country,
  //           isSelected: data.isSelected,
  //           isDisabled: data.isDisabled,
  //         };
  //       }
  //       return { ...country };
  //     });
  //   });
  //   setDisplayCountrysData({ ...tempCountryData });
  //   handleSelectCountry();
  // };

  const onCountrySubmit = () => {
    analytics?.trackLandingEvents({
      actionType: "Ins_Country_popup_AddDestinationClicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "Ins_Country_popup_AddDestinationClicked"
      }
    });
    setIsCountryError(false);

    if (searchedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "searched_countries",
        payload: searchedCountriesOmn?.current?.join("|") + "|"
      }, "pageView", type);
      searchedCountriesOmn.current = [];
    }

    if (selectedCountriesOmn?.current?.length) {
      analytics?.trackLandingEvents({
        actionType: "selected_countries",
        payload: selectedCountriesOmn?.current?.join("|")
      }, "pageView", type);
      selectedCountriesOmn.current = [];
    }

    let countryDataArr = countryData.map(country => {
      return _objectSpread(_objectSpread({}, country), {}, {
        isSelected: false,
        isDisabled: false
      });
    });
    displayCountryData.map(data => {
      countryDataArr = countryDataArr.map(country => {
        if (country.code === data.code) {
          return _objectSpread(_objectSpread({}, country), {}, {
            isSelected: data.isSelected,
            isDisabled: data.isDisabled
          });
        }

        return _objectSpread({}, country);
      });
    });
    setCountryData(countryDataArr);
    setShowCountry(popularCountries);
    const selectedCountryCodes = displayCountryData.filter(item => item.isSelected && !item.isDisabled).map(item => item.code);
    (0,utils/* replaceHistoryRemoveParams */._A)("countries");
    (0,utils/* replaceHistory */.df)("countries", selectedCountryCodes.join(","));
    const selectedNonPopCountries = displayCountryData.filter(data => data.isSelected && !data.isPopular);
    analytics?.trackLandingEvents({
      actionType: "other_countries_clicked",
      payload: selectedNonPopCountries.map(c => c.name).join("|")
    }, "pageView", type);
    handleSelectCountry && handleSelectCountry();
  };

  const handleSearchTxt = event => {
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      if (searchedCountriesOmn?.current?.length >= 30) {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current?.slice(1), searchTxt];
      } else {
        searchedCountriesOmn.current = [...searchedCountriesOmn?.current, searchTxt];
      }
    }

    setSearchTxt(_ => event.target.value);
    onSearchChange(event.target.value);
  };

  const searchClickAnalytics = () => {
    analytics?.trackLandingEvents({
      actionType: "Ins_Country_popup_searchclicked"
    }, "pageView", type);

    if (!singleSearchSelection.current) {
      singleSearchSelection.current = true;
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "Ins_Country_popup_searchclicked"
        }
      });
    }
  };

  const renderContent = () => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      onClick: searchClickAnalytics,
      "data-test-id": "SelectCountryModalV2-renderContent",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.TMFloatingInput, {
        handleChange: e => handleSearchTxt(e),
        inputValue: searchTxt,
        labelTxt: "Search Country/Region",
        defaultFocus: focusSearchOnOpen,
        "data-test-id": "SelectCountryModalV2-renderContent-TMFloatingInput"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalV2_style/* CountrySectionWrap */.pg, {
      "data-test-id": "SelectCountryModalV2-renderContent-CountrySectionWrap",
      children: displayCountryData?.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(CountryList/* default */.Z, {
        countryData: searchTxt.length ? displayCountryData.filter(country => country.type !== "HEADER") : displayCountryData,
        countryHandler: countryClickHandler,
        isCheckedHandler: isCheckedHandler,
        searchQueryHighlighter: searchQueryHighlighter,
        setCountryData: setDisplayCountrysData,
        setIsSelectedError: setIsSelectedError,
        showHeader: !searchTxt.length,
        setCountrySelectToastMsg: setCountrySelectToastMsg,
        "data-test-id": "SelectCountryModalV2-renderContent-CountryList"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
        fontSize: "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "30px 0px 0px 0px",
        "data-test-id": "SelectCountryModalV2-renderContent-ParaTag",
        children: "No Country Found! Please enter correct name"
      })
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModalV2-renderContent-WebToast"
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
      toastTxt: countrySelectErrMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModalV2-renderContent-WebToast"
    }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
      toastTxt: countrySelectToastMsg,
      top: "475px",
      left: "30px",
      height: "40px",
      width: "360px",
      "data-test-id": "SelectCountryModalV2-renderContent-WebToast"
    }), displayCountryData?.length && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalV2_style/* BtnWrap */.Kj, {
      "data-test-id": "SelectCountryModalV2-renderContent-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        margin: "16px 0px 0px 0px",
        customWidth: "100%",
        customTitle: "Add Destination",
        onClick: onCountrySubmit,
        "data-test-id": "SelectCountryModalV2-renderContent-LandingButton"
      })
    })]
  });

  if (isDropdown) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownContainer, {
      ref: dropdownRef,
      "data-test-id": "SelectCountryModalV2-DropdownContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DropdownContent, {
        "data-test-id": "SelectCountryModalV2-DropdownContent",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StickySearchContainer, {
          "data-test-id": "SelectCountryModalV2-StickySearchContainer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: searchClickAnalytics,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(InputWrapper, {
              "data-test-id": "SelectCountryModalV2-InputWrapper",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputIcon, {
                "data-test-id": "SelectCountryModalV2-InputIcon",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/ic_search_5e79fda6b3.png",
                  width: "9px",
                  height: "9px"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CountryInput, {
                onChange: e => handleSearchTxt(e),
                placeholder: "Search Country/Region",
                autoFocus: true,
                "data-test-id": "SelectCountryModalV2-CountryInput"
              })]
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollableContent, {
          "data-test-id": "SelectCountryModalV2-ScrollableContent",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCountryModalV2_style/* CountrySectionWrap */.pg, {
            "data-test-id": "SelectCountryModalV2-CountrySectionWrap",
            children: displayCountryData?.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(CountryList/* default */.Z, {
              customHeight: window.innerHeight * 0.3,
              countryData: searchTxt.length ? displayCountryData.filter(country => country.type !== "HEADER") : displayCountryData,
              countryHandler: countryClickHandler,
              isCheckedHandler: isCheckedHandler,
              searchQueryHighlighter: searchQueryHighlighter,
              setCountryData: setDisplayCountrysData,
              setIsSelectedError: setIsSelectedError,
              showHeader: !searchTxt.length,
              setCountrySelectToastMsg: setCountrySelectToastMsg,
              "data-test-id": "SelectCountryModalV2-CountryList"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
              fontSize: "sm",
              color: Global/* theme.greyText */.rS.greyText,
              margin: "30px 0px 0px 0px",
              "data-test-id": "SelectCountryModalV2-ParaTag",
              children: "No Country Found! Please enter correct name"
            })
          })
        }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
          toastTxt: countrySelectErrMsg,
          top: "254px",
          left: "12px",
          height: "40px",
          width: "360px",
          "data-test-id": "SelectCountryModalV2-WebToast"
        }), countrySelectToastMsg && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
          toastTxt: countrySelectToastMsg,
          top: "254px",
          left: "12px",
          height: "40px",
          width: "360px",
          "data-test-id": "SelectCountryModalV2-WebToast"
        }), displayCountryData?.length && /*#__PURE__*/(0,jsx_runtime.jsx)(StickyButtonContainer, {
          "data-test-id": "SelectCountryModalV2-StickyButtonContainer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
            customWidth: "28%",
            customHeight: "32px",
            customTitle: "Apply",
            onClick: onCountrySubmit,
            "data-test-id": "SelectCountryModalV2-LandingButton"
          })
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(RegionCountryModal/* default */.Z, {
    customHeight: "600px",
    handleClick: onCountrySubmit,
    customTitle: "Select Destinations",
    customSubTitle: customSubTitle,
    "data-test-id": "SelectCountryModalV2-RegionCountryModal",
    children: renderContent()
  });
};

/* harmony default export */ const SelectCountryModal_SelectCountryModalV2 = (SelectCountryModalV2);

/***/ }),

/***/ 99156:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": () => (/* binding */ ShimmerVersion3Style),
/* harmony export */   "aW": () => (/* binding */ ShimmerVersion2Style),
/* harmony export */   "zn": () => (/* binding */ ShimmerComp)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);

const shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .keyframes */ .F4)(["0%{background-position:50% 0;}100%{background-position:-50% 0;}"]);
const ShimmerComp = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Shimmerstyle__ShimmerComp",
  componentId: "sc-1fovdgs-0"
})(["animation:", " 1s linear infinite;background:linear-gradient(to right,#2F2F2F  8%,#393939 18%,#2F2F2F   33%);background-size:800px 104px;position:relative;border-radius:4px;width:", ";height:", ";margin:", ";position:relative;flex-shrink:0;padding:", ";display:flex;align-items:flex-end;}"], shimmer, p => p.width ? p.width : "100%", p => p.height ? p.height : "14px", p => p.margin ? p.margin : "", p => p.padding ? p.padding : "");
const ShimmerVersion2Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion2Style",
  componentId: "sc-1fovdgs-1"
})(["background:linear-gradient(to right,#f6f6f6 8%,#f9fafb 18%,#f6f6f6 33%);background-size:800px 104px;"]);
const ShimmerVersion3Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(ShimmerComp).withConfig({
  displayName: "Shimmerstyle__ShimmerVersion3Style",
  componentId: "sc-1fovdgs-2"
})(["background:linear-gradient(to right,#cbcbcb 8%,#f9fafb 18%,#cbcbcb 33%);background-size:800px 104px;"]);

/***/ }),

/***/ 83531:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ Shimmer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Shimmer_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);



function Shimmer({
  width,
  height,
  margin,
  padding,
  children
}) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_Shimmer_style__WEBPACK_IMPORTED_MODULE_1__/* .ShimmerComp */ .zn, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerComp",
    children: [" ", children]
  });
}

/***/ }),

/***/ 6456:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ ShimmerVersion2)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Shimmer_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);



function ShimmerVersion2({
  width,
  height,
  margin,
  children,
  padding
}) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Shimmer_style__WEBPACK_IMPORTED_MODULE_1__/* .ShimmerVersion2Style */ .aW, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerVersion2Style",
    children: children
  });
}

/***/ }),

/***/ 20863:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ ShimmerVersion3)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Shimmer_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);



function ShimmerVersion3({
  width,
  height,
  margin,
  children,
  padding
}) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Shimmer_style__WEBPACK_IMPORTED_MODULE_1__/* .ShimmerVersion3Style */ .Jh, {
    padding: padding,
    width: width,
    height: height,
    margin: margin,
    "data-test-id": "ShimmerVersion3Style",
    children: children
  });
}

/***/ }),

/***/ 60200:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ShowInsPlan_ShowInsPlan)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/RadioButton/RadioButton.style.ts
var RadioButton_style = __webpack_require__(33570);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ShowInsPlan/ShowInsPlan.style.ts


const ShowInsPlanStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ShowInsPlanstyle__ShowInsPlanStyle",
  componentId: "sc-1vtw87g-0"
})(["border:1px solid #e8e8e8;border-radius:8px;flex:1;background:#fff;margin:", ";display:flex;flex-direction:column;", "{text-align:end;[type=\"radio\"]:checked + label,[type=\"radio\"]:not(:checked) + label{padding-right:30px;}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{right:0;left:auto;}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{right:3px;left:auto;}}"], p => p.margin ? p.margin : "", RadioButton_style/* RadioButtonStyle */.o);
const ShowInsPlanCntnt = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ShowInsPlanstyle__ShowInsPlanCntnt",
  componentId: "sc-1vtw87g-1"
})(["padding:12px;"]);
const ShowInsSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ShowInsPlanstyle__ShowInsSelect",
  componentId: "sc-1vtw87g-2"
})(["background:#f6f6f6;border-radius:0px 0px 8px 8px;border-top:1px solid transparent;padding:8px 12px;display:flex;align-items:flex-end;margin-top:auto;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ShowInsPlan/ShowInsPlan.tsx







const ShowInsPlan = ({
  data,
  margin
}) => {
  const {
    0: selectPlan,
    1: setSelectPlan
  } = (0,react.useState)(-1);

  const handleSelectPlan = index => {
    setSelectPlan(index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
    gap: "12px",
    margin: margin,
    "data-test-id": "ShowInsPlan-FlexComp",
    children: data && data.map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ShowInsPlanStyle, {
        onClick: () => handleSelectPlan(index),
        planSelected: selectPlan == index,
        "data-test-id": `ShowInsPlan-ShowInsPlanStyle-${index}`,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ShowInsPlanCntnt, {
          "data-test-id": "ShowInsPlan-ShowInsPlanCntnt",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            gap: "8px",
            alignItems: "center",
            margin: "0 0 8px",
            "data-test-id": "ShowInsPlan-FlexComp",
            children: [item.planIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              width: "24px",
              height: "24px",
              src: item.planIcon,
              "data-test-id": "ShowInsPlan-ImageComponent"
            }), item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "sm",
              fontWeight: "black",
              color: Global/* theme.blackText */.rS.blackText,
              margin: "0 0 0 8px",
              "data-test-id": "ShowInsPlan-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: item.title,
                "data-test-id": "ShowInsPlan-FormattedText"
              })
            })]
          }), item.planInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
            fontSize: "xs",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "ShowInsPlan-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: item.planInfo,
              "data-test-id": "ShowInsPlan-FormattedText"
            })
          })]
        })
      }, index);
    })
  });
};

/* harmony default export */ const ShowInsPlan_ShowInsPlan = (ShowInsPlan);

/***/ }),

/***/ 15364:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ SocialLogos_SocialLogos)
});

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SocialLogos/SocialLogos.styles.tsx

const SocialMediaLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SocialLogosstyles__SocialMediaLinks",
  componentId: "sc-1udv9uo-0"
})(["display:flex;gap:40px;align-items:center;"]);
const SocialLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "SocialLogosstyles__SocialLink",
  componentId: "sc-1udv9uo-1"
})(["display:flex;justify-content:center;align-items:center;width:48px;height:48px;transition:opacity 0.3s ease;&:hover{opacity:0.8;}"]);
const SocialIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "SocialLogosstyles__SocialIcon",
  componentId: "sc-1udv9uo-2"
})(["background-image:url(\"//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/landingSprite2@3x.png\");background-repeat:no-repeat;display:inline-block;background-size:200px 700px;font-size:0;&.instagramIcon{width:47px;height:46px;background-position:-63px -50px;}&.twiiterIcon{width:36px;height:37px;background-position:-120px -52px;}&.linkedinIcon{width:44px;height:45px;background-position:-8px -51px;}&.facebookIcon{width:20px;height:42px;background-position:-166px -48px;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/SocialLogos/SocialLogos.tsx




const SocialLogos = () => {
  const ORG_INSTA_LINK = "https://www.instagram.com/makemytrip/";
  const ORG_X_LINK = "https://x.com/makemytrip";
  const ORG_LI_LINK = "https://in.linkedin.com/company/makemytrip.com?open=outside";
  const ORG_FB_LINK = "https://www.facebook.com/makemytrip/";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SocialMediaLinks, {
    "data-test-id": "SocialLogos-SocialMediaLinks",
    children: [ORG_INSTA_LINK && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialLink, {
      href: ORG_INSTA_LINK,
      "data-test-id": "SocialLogos-SocialLink",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SocialIcon, {
        className: "instagramIcon landingSprite2",
        "data-test-id": "SocialLogos-SocialIcon"
      })
    }), ORG_X_LINK && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialLink, {
      href: ORG_X_LINK,
      "data-test-id": "SocialLogos-SocialLink",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SocialIcon, {
        className: "twiiterIcon landingSprite2",
        "data-test-id": "SocialLogos-SocialIcon"
      })
    }), ORG_LI_LINK && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialLink, {
      href: ORG_LI_LINK,
      "data-test-id": "SocialLogos-SocialLink",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SocialIcon, {
        className: "linkedinIcon landingSprite2",
        "data-test-id": "SocialLogos-SocialIcon"
      })
    }), ORG_FB_LINK && /*#__PURE__*/(0,jsx_runtime.jsx)(SocialLink, {
      href: ORG_FB_LINK,
      "data-test-id": "SocialLogos-SocialLink",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SocialIcon, {
        className: "facebookIcon landingSprite2",
        "data-test-id": "SocialLogos-SocialIcon"
      })
    })]
  });
};

/* harmony default export */ const SocialLogos_SocialLogos = (SocialLogos);

/***/ }),

/***/ 63161:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Spinner_Spinner)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Spinner/Spinner.styles.ts

const rotate = (0,styled_components_browser_esm/* keyframes */.F4)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
const SpinnerCont = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Spinnerstyles__SpinnerCont",
  componentId: "sc-1pp3kmk-0"
})(["display:inline-block;height:22px;width:22px;animation:", " 1s linear infinite;border-right-color:transparent;border-radius:50%;margin:-2px auto;"], rotate);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Spinner/Spinner.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const Spinner = ({
  spinnerWidth = 22,
  spinnerColor = "#0189d2",
  thickness = 2,
  customStyle
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpinnerCont, {
    style: _objectSpread({
      width: spinnerWidth,
      height: spinnerWidth,
      border: `${thickness}px solid ${spinnerColor}`,
      borderRightColor: "transparent"
    }, customStyle),
    "data-test-id": "Spinner-SpinnerCont"
  });
};

/* harmony default export */ const Spinner_Spinner = (Spinner);

/***/ }),

/***/ 40599:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZR": () => (/* binding */ VerifiedContainer),
/* harmony export */   "dd": () => (/* binding */ TMInputWrap),
/* harmony export */   "qT": () => (/* binding */ InputWpr),
/* harmony export */   "qk": () => (/* binding */ IconContainer),
/* harmony export */   "se": () => (/* binding */ TMInputStyle)
/* harmony export */ });
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);


const TMInputWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__TMInputWrap",
  componentId: "l84rpp-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;label{font-weight:700;font-size:14px;line-height:20px;color:", ";display:block;transition:all 0.3s ease;display:inline-block;position:absolute;left:10px;top:18px;text-transform:uppercase;", " ", "}", " label span{font-weight:400;text-transform:lowercase;}"], props => props.margin, props => props.inputWidth, p => p.flex ? p.flex : "", _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText, props => props.placeholder && `
    color: var(--tm-accent-color);
    background: var(--tm-accent-bg-color);
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    top: 5px;
    `, props => props.disableState && `
        pointer-events: none;
        color: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlack */ .rS.lightBlack};
    `, props => props.clickable && `
        cursor: pointer;
        background:${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText};
        color: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText}
    `);
const TMInputStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "TMFloatingInputstyle__TMInputStyle",
  componentId: "l84rpp-1"
})(["background:", ";border:1px solid ", ";border-radius:4px;padding:26px 10px 10px;font-weight:700;font-size:14px;line-height:19px;display:block;width:100%;", " &:focus + label{color:var(--tm-accent-color);background:var(--tm-accent-bg-color);font-weight:700;font-size:12px;line-height:16px;top:5px;", "}&:valid + label{color:", ";background:", ";font-weight:700;font-size:12px;line-height:16px;top:5px;", " ", " ", " ", "}", " ", " ", " &:focus{outline:none;border:1px solid var(--tm-accent-color);background:", ";}&:valid{outline:none;border:1px solid ", ";background:", ";", "}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gray97 */ .rS.gray97, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightGrey */ .rS.lightGrey, props => props.verifiedTag && `
        padding-right: 80px;
    `, props => props.errorState && `
        color: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.redText2 */ .rS.redText2};
    `, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText6 */ .rS.greyText6, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.smokeWhite */ .rS.smokeWhite, props => props.isActive && `
            color: var(--tm-accent-color);
            background: var(--tm-accent-bg-color);
        `, props => props.placeholder && `
            color: var(--tm-accent-color);
            background: var(--tm-accent-bg-color);
        `, props => props.errorState && `
             color: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.redText2 */ .rS.redText2};
     `, props => props.clickable && `
        background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText};
    `, props => props.disableState && `
        pointer-events: none;
        color:  ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlack */ .rS.lightBlack};
        border: 1px solid ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightSilver */ .rS.lightSilver};
        background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText};
    `, props => props.clickable && `
        pointer-events: none;
        background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText}  !important;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
    `, props => props.errorState && `
      border: 1px solid ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.redText2 */ .rS.redText2} !important;
      background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.snowWhite */ .rS.snowWhite}  !important;
    `, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.gainsBoro */ .rS.gainsBoro, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.smokeWhite */ .rS.smokeWhite, props => props.isActive && `
            border: 1px solid var(--tm-accent-color);
            background: var(--tm-accent-bg-color);
        `);
const VerifiedContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__VerifiedContainer",
  componentId: "l84rpp-2"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);
const InputWpr = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__InputWpr",
  componentId: "l84rpp-3"
})(["position:relative;"]);
const IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TMFloatingInputstyle__IconContainer",
  componentId: "l84rpp-4"
})(["position:absolute;top:50%;right:16px;transform:translateY(-50%);"]);

/***/ }),

/***/ 14802:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40599);
/* harmony import */ var _icons_DownArrow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96766);
/* harmony import */ var _icons_EditIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2384);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52322);









const TMFloatingInput = ({
  placeholderTxt,
  labelTxt,
  disableState,
  inputWidth,
  margin,
  errorState,
  inputValue,
  handleChange,
  verifiedTag,
  maxLength,
  onFocus,
  onBlur,
  type = "text",
  inputMode,
  flex,
  fieldType = "text",
  showEdit = false,
  handleEditClick,
  handleDropdownPress,
  defaultFocus = false
}) => {
  const {
    0: isFocus,
    1: setIsFocus
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (defaultFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [defaultFocus]);

  const inputFocusHandler = event => {
    if (fieldType === "select") {
      event.preventDefault();
      event.currentTarget.blur();
    }

    !(fieldType === "select") && setIsFocus(true);
    onFocus && onFocus();
  };

  const inputBlurHandler = () => {
    !(fieldType === "select") && setIsFocus(false);
    onBlur && onBlur();
  };

  const handleClick = () => {
    if (fieldType === "select" && handleDropdownPress) {
      handleDropdownPress();
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__/* .TMInputWrap */ .dd, {
    disableState: disableState,
    margin: margin,
    inputWidth: inputWidth,
    flex: flex,
    placeholder: placeholderTxt,
    clickable: fieldType === "select",
    onClick: handleClick,
    "data-test-id": "TMFloatingInput-TMInputWrap",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__/* .InputWpr */ .qT, {
      "data-test-id": "TMFloatingInput-InputWpr",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__/* .TMInputStyle */ .se, {
        ref: inputRef,
        id: labelTxt,
        isActive: isFocus,
        inputMode: inputMode,
        onChange: fieldType === "select" ? () => {} : handleChange,
        value: inputValue,
        errorState: errorState,
        onBlur: inputBlurHandler,
        verifiedTag: verifiedTag,
        disableState: disableState,
        onFocus: inputFocusHandler,
        placeholder: placeholderTxt,
        spellCheck: "false",
        maxLength: maxLength,
        type: type,
        required: true,
        clickable: fieldType === "select",
        "data-test-id": "TMFloatingInput-TMInputStyle"
      }), labelTxt && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
        htmlFor: fieldType === "select" ? "" : labelTxt,
        className: "labelText",
        "data-test-id": "TMFloatingInput-label",
        children: labelTxt
      }), fieldType === "text" && verifiedTag && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__/* .VerifiedContainer */ .ZR, {
        "data-test-id": "TMFloatingInput-VerifiedContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
          fontSize: "xs",
          fontWeight: "bold",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.darkGreen */ .rS.darkGreen,
          "data-test-id": "TMFloatingInput-ParaTag",
          children: verifiedTag
        })
      }), fieldType === "text" && showEdit && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__/* .IconContainer */ .qk, {
        onClick: handleEditClick,
        "data-test-id": "TMFloatingInput-IconContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_EditIcon__WEBPACK_IMPORTED_MODULE_5__/* .EditIcon */ .d, {
          "data-test-id": "TMFloatingInput-EditIcon"
        })
      }), fieldType === "select" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_3__/* .IconContainer */ .qk, {
        "data-test-id": "TMFloatingInput-IconContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_DownArrow__WEBPACK_IMPORTED_MODULE_4__/* .DownArrow */ .p, {
          "data-test-id": "TMFloatingInput-DownArrow"
        })
      })]
    }), errorState && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
      margin: "4px 0 0",
      color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.redText2 */ .rS.redText2,
      fontSize: "xs",
      dangerousText: errorState,
      "data-test-id": "TMFloatingInput-ParaTag"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TMFloatingInput);

/***/ }),

/***/ 76450:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87109);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const DesktopRating = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()( //@ts-ignore
() => Promise.all(/* import() */[__webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726)]).then(__webpack_require__.t.bind(__webpack_require__, 91371, 23)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(91371)]
  }
});
const PwaRating = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()( //@ts-ignore
() => Promise.all(/* import() */[__webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726)]).then(__webpack_require__.t.bind(__webpack_require__, 67116, 23)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(67116)]
  }
});

const TmNPSFeedback = ({
  onFeedbackCloseAnalytics,
  onSubmitFeedbackAnalytics,
  bookingId
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_0__/* .useBreakpointV2 */ .bU)();
  const {
    0: showFeedbackForm,
    1: setShowFeedbackForm
  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    const originalStyle = document.body.style.overflow;

    if (showFeedbackForm) {
      document.body.style.setProperty("overflow", "hidden", "important");
    }

    return () => {
      document.body.style.overflow = originalStyle || "";
    };
  }, [showFeedbackForm]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (bookingId !== null) {
      setShowFeedbackForm(true);
      const cookieName = `npsFeedback_${bookingId}`;
      const existingCookie = document.cookie.split("; ").find(row => row.startsWith(`${cookieName}=`));

      if (existingCookie) {
        setShowFeedbackForm(false);
      }
    }
  }, [bookingId]);

  const npsCookieMaker = () => {
    const cookieName = `npsFeedback_${bookingId}`;
    const existingCookie = document.cookie.split("; ").find(row => row.startsWith(`${cookieName}=`));

    if (!existingCookie) {
      document.cookie = `${cookieName}=true; expires=${new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString()}; path=/`;
      setShowFeedbackForm(true);
    }
  };

  const onFeedbackClose = () => {
    onFeedbackCloseAnalytics();
    npsCookieMaker();
    setShowFeedbackForm(false);
  };

  const onSubmitFeedback = feedbackData => {
    onSubmitFeedbackAnalytics(feedbackData);
    npsCookieMaker();
    setShowFeedbackForm(false);
  };

  const FeedbackComponent = device === "lg" ? DesktopRating : PwaRating;
  const feedbackSource = device === "lg" ? "DWEB" : "PWA";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: showFeedbackForm && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(FeedbackComponent, {
      onFeedbackClose: onFeedbackClose,
      onBeforeSubmitFeedback: onSubmitFeedback,
      bookingId: bookingId,
      bookingDetails: {
        bookingId: bookingId,
        bookingStatus: "success",
        source: feedbackSource,
        // lob: "Forex",
        // category: "Forex_PC_Buy",
        org: "MMT"
      },
      "data-test-id": "TmNPSFeedback-FeedbackComponent"
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TmNPSFeedback);

/***/ })

}]);